<template>
  <div class="m-0 dbozone-font">
    <div class="col-12 justify-content-center d-flex flex-row header-kraken">
      <div class="px-3 col-3 p-0">
        <div class="heading-kraken">{{ $t('result.round') }}</div>
        <div class="text-subhead">{{ data.roundId }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-kraken">{{ $t('result.bet') + `${currency}` }}</div>
        <div class="text-subhead">{{ data.bet | currencyFormatter }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-kraken">{{ $t('result.winlose') + `${currency}` }}</div>
        <div class="text-subhead">{{ data.winlose | currencyFormatter }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-kraken">{{ $t('result.balance') + `${currency}` }}</div>
        <div class="text-subhead">{{ data.balance | currencyFormatter }}</div>
      </div>
    </div>
    <div class="content-result-kraken pt-3">
      <div class="text-games-kraken">{{ 'KRAKEN' }}</div>
      <div class="text-subgame">{{ $t('kraken.name') }}</div>
      <div class="text-date mb-1">{{ data.timestamp }}</div>
      <div class="col-12 justify-content-center d-flex flex-row p-0">
        <div class="table-kraken container d-flex flex-column justify-content-center">
          <table>
            <tbody>
              <tr v-for="(row, index) in table" :key="index">
                <td v-for="(col, i) in row" :key="`${index}${i}`">
                  <img
                    :class="i === 0 ? 'icon-symbol-kraken-left' : i === 2 ? 'icon-symbol-kraken-right' : 'icon-symbol-kraken'"
                    :src="require(`../../assets/resultGame/kraken/symbol_${col}.png`)">
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row">
        <hr class="line col-3">
        <div class="text-detail align-items-center d-flex px-3">{{ $t('result.detail') }}</div>
        <hr class="line col-3">
      </div>
      <div class="col-12 justify-content-center d-flex flex-row">
        <div class="bet-wrapper-kraken item">
          <div class="d-flex mt-2 ml-2 justify-content-center">
            <p v-if="data.detail.winning !== 0" class="text-reult-kraken mb-2">{{ $t('result.winning') }}</p>
            <p v-else class="text-reult-kraken">{{ $t('result.nowin') }}</p>
          </div>
          <div class="d-flex justify-content-center col-12 row item p-0">
            <div class="d-flex flex-column align-items-start justify-content-center ml-4">
              <span class="">{{ $t('result.bet') }} : {{ data.bet | currencyFormatter }}</span>
            </div>
            <div class="d-flex flex-column justify-content-center ml-4 text-win">
              <span class="">{{ $t('result.win') }} : {{ winning | currencyFormatter }} {{ currency
                }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '../../services/utils'
export default {
  name: 'result-kraken',
  props: {
    data: Object,
  },
  data() {
    return {
      headerHeight: null,
      table: [
        [1, 2, 3]
      ],
      dateTimeFormatter: function formatter(date) { return utils.dateTimeFormatter(date) },
      tokenData: utils.getTokenData(this.$route.query.t),
      date: '',
      time: '',
      // result: this.data,
      count: this.data.count,
      countSymbol: [],
      symbolsDetail: [],
      bonusGames: false,
      symbolsBonus: [],
      currency: this.data.currency ? this.data.currency : 'THB',
      ratecurrency: this.data.rateCurrency ? this.data.rateCurrency : 1,
    }
  },
  async created() {
    if (this.isback) {
      this.data.count = this.data.detail.summary.length - 1;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
    else {
      this.data.count = 0;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
  },
  methods: {
    onResize() {
      this.headerHeight = document.getElementsByClassName('header-kraken')[0].offsetHeight
    },
    mapSymbol(result) {
      if (!this.currency.includes("(")) {
        this.currency = this.tokenData.isSymb === false ? '' : `(${this.currency})`;
      }
      this.table[0][0] = this.data.game.config.baseGameReel1[result.baseReelStopIndexes[0]]
      this.table[0][1] = this.data.game.config.baseGameReel2[result.baseReelStopIndexes[1]]
      this.table[0][2] = this.data.game.config.baseGameReel3[result.baseReelStopIndexes[2]]
      this.winning = result.winning;
      if (result.isCoin) this.currency = 'AMS';
    },
  }
}
</script>

<style scoped>
.icon-detail-tdessert {
  width: 85px;
  height: 100px;
  padding: 4px;
}

.icon-bonus-tdessert {
  width: 100px;
  height: 100px;
  padding: 10px;
}

.arrow {
  color: #cac095;
  text-align: center;
}

.arrow-side-tdessert {
  color: #ffff;
  text-align: center;
  font-size: 90px;
}

.arrow-side-monster:hover {
  color: #06112d;
  text-align: center;
  /* font-size: 90px; */
}

.bet-box {
  background: #0c161f;
  border-radius: 10px;
  min-height: 200px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bonus-box {
  background: #0c161f;
  border-radius: 10px;
  min-height: 150px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.text-reult-kraken {
  font-size: 45px;
  color: #89faf6;
  text-shadow: 0px 0px 20px rgb(255, 255, 255);
}

.bet-wrapper-kraken {
  color: #fff;
  background: #042c23;
  line-height: 1;
  border-radius: 15px;
  border: 4px solid #89faf6;
  height: 170px;
  width: 560px;
  margin-top: 8%;
}

.bet-box .bet-wrapper-kraken:not(:first-child) .item {
  margin-top: 10px;
}

.bet-wrapper-kraken,
.result-wrapper {
  font-size: 35px;
}

.header-kraken {
  background: #146757;
  padding: 10px 0;
  flex-wrap: wrap;
}

.header-kraken>div {
  flex-grow: 1;
  font-size: 20px;
  line-height: 1.1;
}

.heading-kraken {
  color: #89faf6;
  text-align: center;
}

.content-result-kraken {
  background: #042c23;
  height: 150vh;
  width: 100%;
  background-size: cover;
  background-attachment: scroll;
  background-repeat: no-repeat;
}

.title>.heading-kraken {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 0;
}

.title>.sub {
  font-size: 30px;
  line-height: 1;
}

.text-games-kraken {
  color: #89faf6;
  font-size: 25px;
  text-align: center;
}

.text-subhead {
  font-size: px;
  color: white;
  text-align: center;
}

.text-subgame {
  font-size: 20px;
  color: white;
  text-align: center;
}

.text-date {
  font-size: px;
  color: #c7b873;
  text-align: center;
}

.text-detail {
  font-size: 20px;
  color: #c7b873;
  text-align: center;
}

.icon-symbol-kraken {
  width: 100%;
  padding-inline: 6px;
}

.icon-symbol-kraken-left {
  width: 100%;
  padding-inline-end: 15px;
}

.icon-symbol-kraken-right {
  width: 100%;
  padding-inline-start: 15px;
}

.bet-box {
  min-width: 600px;
  max-width: auto;
}

.table-kraken {
  background: url('~@/assets/resultGame/kraken/slot_frame.png') no-repeat;
  background-size: 590px 270px;
  width: 590px;
  height: 270px;
  border-radius: 5px;
  font-size: 30px;
  text-align: center;
}

@media screen and (max-width: 1030px) {
  .table-kraken {
    background-size: 500px 240px;
    width: 500px;
    height: 240px;
  }

  .wrapper {
    flex-direction: column;
  }

  .wrapper>div:first-child {
    order: 2;
  }

  .wrapper>div:last-child {
    order: 1;
  }

  .arrow-side-monster {
    font-size: 60px;
  }

  .bet-box {
    min-width: 580px;
    max-width: auto;
    height: 280px;
  }

  .bet-wrapper-kraken,
  .result-wrapper {
    font-size: 35px;
  }
}

@media screen and (min-width: 1060px) {

  .d-md-spec-flex {
    display: flex;
  }

  .result-wrapper .symbol {
    width: 140px;
  }

  .bet-wrapper-kraken,
  .result-wrapper {
    font-size: 33px;
  }

}

.line {
  background-color: #c7b873;
  height: 2px;
  width: 100%;
}

.red {
  color: #ff0000;
}

.green {
  color: #10b24b;
}

@media screen and (max-width: 770px) {
  .heading-kraken {
    font-size: 18px;
  }

  .table-kraken {
    background-size: 470px 230px;
    width: 470px;
    height: 230;
    margin-bottom: 1%;
    padding-bottom: 30px;
  }

  .text-subhead {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #c7b873;
    text-align: center;
  }
}

@media screen and (max-width: 480px) {
  .header-kraken>div {
    flex-grow: 0;
    width: 25%;
  }

  .text-win {
    margin-left: 3px;
    margin-top: 5px;
  }

  .heading-kraken {
    font-size: 12px;
  }

  .table-kraken {
    background-size: 270px 120px;
    width: 270px;
    height: 120px;
    padding-top: 1.6rem;
  }

  .text-subhead {
    font-size: 14px;
  }

  .bet-box {
    min-width: 230px;
    max-width: auto;
    height: 200px;
  }

  .bet-wrapper-kraken {
    color: #fff;
    background: #042c23;
    line-height: 1;
    border-radius: 15px;
    border: 4px solid #89faf6;
    height: 100px;
    width: 230px;
    /* margin-top: 8%; */
  }

  .text-reult-kraken {
    font-size: 15px;
    color: #89faf6;
  }

  .bonus-box {
    min-width: 230px;
    max-width: auto;
    height: 150px;
  }

  /* .bet-wrapper-kraken {
    height: 100px;
    width: 100px;
  } */
  .bet-wrapper-kraken,
  .result-wrapper {
    font-size: 20px;
    /* margin-bottom: ; */
  }

  .icon-detail-tdessert {
    width: 45px;
    height: 50px;
  }

  .icon-bonus-tdessert {
    width: 60px;
    height: 60px;
  }
}

</style>
